import React from 'react';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { Routes, Route, BrowserRouter } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.min.css';
import 'core-js/modules/es7.promise.finally';
import { PersistGate } from 'redux-persist/lib/integration/react';
import { gspx } from '@rsos/capstone';
import '@rsos/capstone/src/overridePublicPath';
import ErrorBoundary from '@rsos/components/capstone/ErrorBoundary';
import NotFound from '@rsos/components/capstone/ErrorBoundary/NotFound';
import Layout from '@rsos/components/capstone/Layout';
import flattenArray from '@rsos/utils/flattenArray';
import App from './app/App';
import { store, persistor } from './store';

if (module.hot) {
  module.hot.accept();
}

gspx.initialize(store);

const topLevelRoutes = [
  'home',
  'query-interface',
  'irp-home',
  'irp-query-interface',
];

const appPaths = flattenArray(topLevelRoutes.map(route => route));

const AppRoutes = () => (
  <Routes>
    {topLevelRoutes.map(route => (
      <Route key={route} path={route} element={<App />} />
    ))}
    <Route path="*" element={<NotFound />} />
  </Routes>
);

ReactDOM.render(
  <Provider store={store}>
    <PersistGate loading={'Loading'} persistor={persistor}>
      <BrowserRouter>
        <Layout appPaths={appPaths} persistor={persistor}>
          <ErrorBoundary>
            <AppRoutes />
          </ErrorBoundary>
        </Layout>
      </BrowserRouter>
    </PersistGate>
  </Provider>,
  document.getElementById('root'),
);
